<template>
  <div>

  <v-layout justify-center align-center style="height: 100%;width: 100%;position: absolute;">
    <v-progress-circular v-if="!dataLoaded"
        :size="64"
        indeterminate
        color="primary">
    </v-progress-circular>
  </v-layout> 

    <v-container v-if="dataLoaded" px-10 fill-height ms-auto class="pop-container openEnquiryPage">  
    
      <v-stepper non-linear>
        <div class="c-stepper__header">
          <div tabindex="-1" class="c-stepper__step">
              <span class="c-stepper__step__step primary"><v-icon  icon="icon" color="white">mdi-content-save-cog</v-icon></span>
            <div class="c-stepper__label">{{ $let('OpenEnquirySectionTitle') }}</div>
          </div>
        </div>
      </v-stepper>
  
      <v-row no-gutters>
        <v-col>
          <v-sheet color="white" class="custom-shadow pa-10">  
            <div v-html="pageSubTitle"></div>

            <v-row no-gutters>
              <v-col cols="12" sm="12" md="12">  
                <v-form ref="inputForm" @submit.prevent="">
                  <div class="my-5">
                    <TextField 
                      type="number"
                      v-if="enquiryKeyFound"
                      v-model="model.otpCode"
                      :label="$let('MobileNumberOTPEntry')"
                      :rules="[validationRules.numeric, validationRules.required]">
                    </TextField>
                    <div class="error-text__open text-center" v-html="pageErrorMessage"></div>
                  </div>
                  <div class="text-center">
                    <BaseButton
                      v-if="enquiryKeyFound"
                      :inAction="inAction"
                      @click="_validateOTP"
                      :label="$let('ContinueButtonLabel')">
                    </BaseButton>
                  </div>
                </v-form>
              </v-col>
            </v-row>

          </v-sheet>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import TextField from '@/shared/components/text-field.vue'
  import BaseButton from '@/shared/components/base-button.vue'
  import validators from '@/shared/utils/validators.js';
  import router from '../router/index.js';
  import routerNames from '../router/router-names.js';
  import constants from '../constants/generic.js'

  export default {
    name: 'OpenEnquiry',
    components: {
        TextField,
        BaseButton
    },
    props: {
      dataLoaded: { type: Boolean, default: false },
    },    
    data() {
      return {
        enquiryKeyFound: false,
        validationRules: {},
        pageSubTitle: '',
        pageErrorMessage: '',
        inAction: false,
        model: {
          otpCode: '',
          accessToken: '',
          enquiryKey: this.$route.params.id,
        }
      };
    },
    async created() {
      if (this.enquiryKey === "") router.push({ name: routerNames.Home})
      else {
        const resp = await this.requestOpen(this.model);
        if (resp.Code === constants.LOAN_ENQUIRY_SUCCESS) {
          this.enquiryKeyFound = true;
          this.pageSubTitle = this.$let('OpenEnquirySectionSubTitle').replaceAll("{OwnerName}", resp.Data.OwnerName)
                                                                     .replaceAll("{MobileNumberMask}", resp.Data.MobileNumberMask);
          // Validators with locale texts
          this.validationRules = validators.validationRules({ reqFld: this.$let('RequiredFieldEmptyMessage') });
        }
        else if (resp.Code === constants.LOAN_ENQUIRY_NOT_FOUND) this.pageSubTitle = this.$let('OpenEnquiryKeyNotFound');
      }
    },

    methods: {
      ...mapActions(["requestOpen", "openEnquiry"]),

      async _validateOTP() {
        if (this.$refs.inputForm.validate()) {
          this.inAction = true;
          const resp = await this.openEnquiry(this.model);
          if (resp.Code === constants.LOAN_ENQUIRY_SUCCESS) router.push({ name: routerNames.DocPack});
          else if (resp.Code === constants.LOAN_ENQUIRY_UNAUTHORIZED) this.pageErrorMessage = this.$let('OpenEnquiryInvalidOTP');
          this.inAction = false;
        }
      }
    },
  };
</script>

<style lang="scss" scoped>

</style>